import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";
import { formatCompactCurrency } from "./analyticsUtils";

ChartJS.register(
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
);

const AnalyticsPrimaryChart = ({
  view,
  chartData,
  loading,
  error,
  title,
  subtitle,
  emptyMessage,
}) => {
  return (
    <div className="rounded-3xl bg-white p-5 shadow">
      <div className="mb-4 flex flex-col gap-1">
        <h2 className="text-lg font-semibold text-zinc-900">{title}</h2>
        <p className="text-sm text-zinc-500">{subtitle}</p>
      </div>

      {loading ? (
        <div className="flex h-[360px] items-center justify-center text-zinc-500">
          Loading analytics...
        </div>
      ) : error ? (
        <div className="flex h-[360px] items-center justify-center text-center text-red-600">
          {error}
        </div>
      ) : !chartData ? (
        <div className="flex h-[360px] items-center justify-center text-zinc-500">
          {emptyMessage}
        </div>
      ) : view === "trend" ? (
        <div className="h-[360px]">
          <Line
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              interaction: { mode: "index", intersect: false },
              plugins: {
                legend: { position: "top" },
                tooltip: {
                  callbacks: {
                    label: (context) =>
                      `${context.dataset.label}: ${formatCompactCurrency(
                        context.parsed.y
                      )}`,
                  },
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => formatCompactCurrency(value),
                  },
                },
              },
            }}
          />
        </div>
      ) : (
        <div className={view === "muqami" ? "h-[520px]" : "h-[360px]"}>
          <Bar
            data={chartData}
            options={{
              indexAxis: "y",
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: (context) => formatCompactCurrency(context.parsed.x),
                  },
                },
              },
              scales: {
                x: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => formatCompactCurrency(value),
                  },
                },
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AnalyticsPrimaryChart;
